import type { ReactNode } from 'react'
import styles from './Sidebar.module.css'

export interface SidebarSectionProps {
  label: string
  children: ReactNode
}

export function SidebarSection({ label, children }: SidebarSectionProps) {
  return (
    <div className={styles.section}>
      <div className={styles.sectionLabel}>{label}</div>
      {/* The heading is visual only; the group role is what carries the
          section name to assistive tech — and it is the only thing that does
          once the sidebar collapses and the label is hidden. */}
      <div
        className={styles.sectionItems}
        role={label ? 'group' : undefined}
        aria-label={label || undefined}
      >
        {children}
      </div>
    </div>
  )
}
